import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { scrollToElement } from '../../../libs/gin-tonic/helpers/scroll/scroll-to-element/index';

@Component({ className: 'js-form-prevalue' })
export class PreValueComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener('click', e => {
			e.preventDefault();
			const preValue = this.element.getAttribute('data-prevalue');
			const forms = Array.from(document.forms);
			// forms?.find(o => Array.from(o.elements).some(f => f.nodeName == 'SELECT' && Array.from((f as HTMLSelectElement).options).some(opt => opt.text == preValue)))
			if (forms && forms.length) {
				forms.forEach(form => {
					const selects = Array.from(form.elements).filter(f => f.nodeName == 'SELECT');
					selects.forEach(select => {
						const options = Array.from((select as HTMLSelectElement).options);
						const preValueOption = options.find(opt => opt.text == preValue);
						if (preValueOption) {
							options.forEach(o => (o.selected = false));
							preValueOption.selected = true;
							scrollToElement(form);
							return;
						}
					});
				});
			}
		});
	}
}
